/**
 * Internal dependencies.
 */
import edit from './edit';
import save from './save';
import metadata from './block.json';
import { ServiceIcon as icon } from '../../components/Icons';

/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { Icon } from '@wordpress/components';

/**
 * Block constants
 */
const { name, category, attributes, supports } = metadata;

const settings = {
	title: __( 'Service' ),
	description: __( 'Gutenify Service.' ),
	icon: <Icon icon={ icon } />,
	keywords: [
		'gutenify',
		__( 'Service' ),
		__( 'Services' ),
	],
	example: {
		attributes: {
			service: {

			},
		},
	},
	attributes,
	edit,
	save,
	supports,
};

export { name, category, settings };
